// Calculul vechimii în ani și luni — aceeași regulă ca backend/core/seniority.py (luni calendaristice întregi între data de
// început și ziua de după data de referință; zilele rămase se adună, 30 de zile = o lună).
const parse = (iso) => { const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || ""); return m ? { y: +m[1], m: +m[2], d: +m[3] } : null; };
const daysIn = (y, m) => new Date(y, m, 0).getDate();

export function tenure(startIso, refIso) {
  const s = parse(startIso), r = parse(refIso);
  if (!s || !r) return null;
  if (Date.UTC(s.y, s.m - 1, s.d) > Date.UTC(r.y, r.m - 1, r.d)) return { years: 0, months: 0 };
  const stop = new Date(Date.UTC(r.y, r.m - 1, r.d + 1));
  const sy = stop.getUTCFullYear(), sm = stop.getUTCMonth() + 1, sd = stop.getUTCDate();
  let months = (sy - s.y) * 12 + (sm - s.m), days = sd - s.d;
  if (days < 0) {
    months -= 1;
    const [py, pm] = sm > 1 ? [sy, sm - 1] : [sy - 1, 12];
    days += daysIn(py, pm);
  }
  const total = months + Math.floor(days / 30);
  return { years: Math.floor(total / 12), months: total % 12 };
}

export const KINDS = [["work", "Vechime în muncă"], ["specialty", "Vechime în specialitate"], ["employer", "Vechime la angajator"]];

export const fmtDate = (iso) => { const p = parse(iso); return p ? `${String(p.d).padStart(2, "0")}.${String(p.m).padStart(2, "0")}.${p.y}` : ""; };
